import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { getCredits } from "../services/creditService";
import { setCredits } from "../redux/slices/creditSlice";

// Hooks
export const useFetchTokens = ({ enabled }) => {
  const dispatch = useDispatch();

  const callback = (tokens) => {
    if (!tokens?.cvCredits && typeof tokens.cvCredits !== "number") {
      throw new Error("Invalid or missing cvCredits while fetching user tokens");
    }

    dispatch(setCredits(tokens));
  };

  return useQuery({
    queryKey: ["tokens"],
    queryFn: () => getCredits(callback),
    enabled,
    retry: 3,
  });
};
